import { useEffect, useMemo, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../hooks';
import { IMember } from '../../../types';
import { OtherTenant } from './components';
import { ActionItem } from 'styles/animations.styled';
import { LoaderWrapper, ToggleWrapper, Wrapper } from './tenants.styled';
import { LinesLoader } from '../../loaders';
import { Toggle } from '../../toggle';
import { ApplicantCard } from '../applicant-card';

interface IProps {
  canCollapsed?: boolean;
  isAnotherInCallCard?: boolean;
  withoutCallback?: boolean;
  id?: string;
  inCallCard?: boolean;
  card?: any;
}

export const Tenants = observer(
  ({
    canCollapsed = true,
    inCallCard,
    isAnotherInCallCard,
    withoutCallback,
    id,
    card,
  }: IProps) => {
    const { createRequest, telephony, aiRequests } = useStore();
    const { anotherMember, setBooleanProperties } = createRequest;
    const { loading, members, memberId, setSelectedId } =
      createRequest.applicant;

    const ref = useRef<HTMLDivElement>(null);
    const [open, setOpen] = useState<boolean>(false);

    const isMembersLoaded =
      !loading.members.pending && loading.members.fulfilled;
    const showOtherTenant = useMemo(() => {
      return (isMembersLoaded && !members.length) || anotherMember;
    }, [members.length, anotherMember, isMembersLoaded]);

    const showAnotherMemberAction = useMemo(() => {
      return !!members.length && !anotherMember && !isAnotherInCallCard;
    }, [members.length, anotherMember, isAnotherInCallCard]);

    useEffect(() => {
      if (!!members[0] && memberId === members[0].id) {
        const callerInfo =
          inCallCard && card ? card.callerInfo : telephony.callerInfo;
        callerInfo.setCallerName(members[0].str_name);
        callerInfo.setCallerEmail(members[0].email || '');
        callerInfo.setCallerPhone(
          members[0].phones[0]?.str_number || createRequest.initialPhoneNumber
        );
      }

      if (isMembersLoaded && !members.length && !anotherMember) {
        setBooleanProperties('anotherMember', true);
      }
    }, [members.length, isMembersLoaded]);

    const isCollapsed: boolean = useMemo(() => canCollapsed && !open, [open]);

    const handleOpen = (): void => {
      setOpen((prevOpen) => !prevOpen);
    };

    const handleChangeAnotherMember = (): void => {
      setSelectedId('memberId', '');
      setBooleanProperties('anotherMember', true);
    };

    return (
      <Wrapper ref={ref}>
        {loading.members.pending ? (
          <LoaderWrapper>
            <LinesLoader size={'medium'} loaderType={'tenant'} />
          </LoaderWrapper>
        ) : (
          <>
            {canCollapsed && !!members.length && (
              <ToggleWrapper isAnotherInCallCard={isAnotherInCallCard}>
                <Toggle
                  open={open}
                  onClick={handleOpen}
                  disabled={aiRequests.isAiMode}
                />
              </ToggleWrapper>
            )}

            {!!members.length &&
              members.map((member: IMember, index: number) => (
                <ApplicantCard
                  key={index}
                  applicant={member}
                  selected={memberId === member.id}
                  collapsed={isCollapsed}
                  canCollapsed={canCollapsed}
                  withoutCallback={withoutCallback}
                  id={id}
                  inCallCard={inCallCard}
                  card={card}
                />
              ))}

            {showOtherTenant ? (
              <OtherTenant
                isSelected={showOtherTenant}
                isCollapsed={isCollapsed}
              />
            ) : showAnotherMemberAction && !aiRequests.isAiMode ? (
              <ActionItem
                isCollapsed={isCollapsed}
                isSelected={false}
                onClick={handleChangeAnotherMember}
              >
                Другой житель
              </ActionItem>
            ) : null}
          </>
        )}
      </Wrapper>
    );
  }
);
